import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetEligibilityRequest } from '@cash-web/shared-util-protos/squareup/cash/cryptosparky/api/deposits/public.pb'
import { GetEligibilityResponse } from '@cash-web/shared-util-protos/squareup/cash/cryptosparky/api/deposits/public.pb'

export const getEligibility = (request: GetEligibilityRequest, options?: CashRequestOptions) =>
  post<GetEligibilityRequest, GetEligibilityResponse>('/2.0/cash/get-eligibility', request, {
    ...options,
    rejectOnError: true,
  })
